export enum RegisterActions {
  Reset = "reset",
  SetUserObject = "setUserObject",
  StaticRegister = "staticRegister",
}
